// Single source of truth for payment-method display (name + emoji) and the
// editable options, shared by the Driver Orders Payment column (WN-0162) and the
// driver Collection Report (WN-0165). Keep codes in sync with oc_order.payment_method.

export const PAYMENT_METHODS = [
  { code: "cod", label: "Cash on Delivery", emoji: "💸" },
  { code: "ccod", label: "Card on Delivery", emoji: "💳" },
  { code: "cliq", label: "CliQ", emoji: "📲" },
  { code: "cc", label: "Credit Card", emoji: "🌐" },
  { code: "bank_transfer", label: "Bank transfer", emoji: "🏦" },
  { code: "free_checkout", label: "Free checkout", emoji: "🎁" },
];

// Map stored variants onto a canonical code. WN-0217: orders are created from
// several sources that saved the method differently (codes, English labels in
// various casings, and Arabic labels), so every known variant is mapped here to
// ONE canonical code — giving a single consistent label/emoji everywhere this
// helper is used, without changing the stored value (editors still use the code).
const ALIASES = {
  payfort: "cc",
  "credit card": "cc",
  "cash on delivery": "cod",
  "cash on delive": "cod",
  "الدفع عند الاستلام": "cod",
  "credit card on delivery": "ccod",
  "card on delivery": "ccod",
  "الدفع ببطاقة الائتمان عند التسليم": "ccod",
  "free checkout": "free_checkout",
  "bank transfer": "bank_transfer",
};

export function paymentInfo(code) {
  const raw = String(code || "").toLowerCase().trim();
  const canonical = ALIASES[raw] || raw;
  return (
    PAYMENT_METHODS.find((m) => m.code === canonical) ||
    { code: raw, label: code ? String(code) : "Not set", emoji: "•" }
  );
}

// "💸 Cash on Delivery"
export function paymentLabel(code) {
  const i = paymentInfo(code);
  return `${i.emoji} ${i.label}`.trim();
}
